import hhlLogo from '../hoggedin.png';
import accnLogo from '../accnlogo.png';
import defaultLogo from '../hoggedin.png';

export const ensureSkillLevel = (level) => {
  if (typeof level === 'number' && Number.isFinite(level)) {
    return level;
  }
  return null;
};

export const createSkillsSnapshot = (skills) => {
  const list = Array.isArray(skills)
    ? skills.map((skill) => ({
        ...skill,
        type: skill?.skilltype ?? skill?.type ?? null,
        level: ensureSkillLevel(skill.level)
      }))
    : [];

  const map = list.reduce((acc, skill) => {
    if (skill?.skillid == null) {
      return acc;
    }
    acc[String(skill.skillid)] = {
      skillname: skill.skillname,
      type: skill.skilltype ?? skill.type ?? null,
      level: ensureSkillLevel(skill.level)
    };
    return acc;
  }, {});

  return { list, map };
};

export const diffSkillsForPayload = (skills) => {
  if (!Array.isArray(skills) || skills.length === 0) {
    return [];
  }

  return skills.reduce((acc, skill) => {
    if (!skill || skill.skillid == null) {
      return acc;
    }
    acc.push({
      skillid: skill.skillid,
      level: skill.level != null && !Number.isNaN(Number(skill.level)) ? Number(skill.level) : null
    });
    return acc;
  }, []);
};

export const normalizeCompaniesForEditing = (entries) => {
  if (!Array.isArray(entries)) {
    return [];
  }
  return entries
    .map((entry, index) => {
      const name = typeof entry?.name === 'string' ? entry.name : entry?.client || '';
      const website = typeof entry?.website === 'string' ? entry.website : '';
      return {
        id: entry?.id ?? `${index}-${Date.now()}`,
        name: name ?? '',
        website: website ?? ''
      };
    })
    .filter((entry) => entry.name || entry.website);
};

export const createEmptyCompanyEntry = () => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  name: '',
  website: ''
});

export const sanitizeCompaniesForPayload = (entries) => {
  if (!Array.isArray(entries)) {
    return [];
  }

  return entries
    .map((entry) => ({
      name: entry?.name?.trim() || '',
      website: entry?.website?.trim() || ''
    }))
    .filter((entry) => entry.name || entry.website);
};

export const resolveBrandAssets = (brand) => {
  if (brand === 'hhl') {
    return { logoSrc: hhlLogo, backgroundColor: '#d3e0ea' };
  }
  if (brand === 'accn') {
    return { logoSrc: accnLogo, backgroundColor: '#d3e0ea' };
  }
  return { logoSrc: defaultLogo, backgroundColor: '#d3e0ea' };
};
